// TUT-476 — o `validateSearch` de `/prazos`, fora do roteador (`router.tsx` não
// passa de mil linhas: catraca da TUT-416). Os filtros da lista de prazos são
// muitos — busca, status, tipo, responsável, a faixa de vencimento do widget
// (TUT-475), o período de vencimento da Série temporal e a conclusão da
// Medição (TUT-476) — e cada um se conferia na rota; agora a regra mora aqui.
import {
  conclusaoDaBuscaDePrazos,
  faixaDaBuscaDePrazos,
} from "../lib/indicadores";
import { isColunaDaLista, isDirecaoDeOrdenacao } from "../lib/list-sorting";
import { periodoDaBusca } from "../lib/periodo-de-datas";
import { pagina, texto, type PrazosSearch } from "./buscas";

export function validarBuscaDePrazos(busca: Record<string, unknown>): PrazosSearch {
  const {
    q,
    status,
    sort,
    dir,
    page,
    tipo,
    responsavel,
    vence,
    dias,
    periodoDe,
    periodoAte,
    concluidoDe,
    concluidoAte,
    noPrazo,
    ...resto
  } = busca;
  return {
    ...resto,
    q: texto(q),
    status: texto(status),
    // TUT-476 — o período de vencimento (Série temporal) e a conclusão da
    // Medição, que só vale com `status=completed` (`conclusaoDaBuscaDePrazos`).
    ...periodoDaBusca({ periodoDe, periodoAte }),
    ...conclusaoDaBuscaDePrazos({
      status: texto(status),
      concluidoDe,
      concluidoAte,
      noPrazo,
    }),
    // TUT-204j — tipo e responsável entram TIPADOS. O tipo é texto com
    // catálogo POR ESCRITÓRIO (`deadline_types`), então quem fecha a lista
    // é a TELA, que conhece o catálogo do tenant.
    tipo: texto(tipo),
    responsavel: texto(responsavel),
    // TUT-475 — a faixa de vencimento é lista FECHADA e só de pendentes, e
    // a janela do widget (`dias`) só vale com ela: a regra é uma só, a de
    // `faixaDaBuscaDePrazos`, que a tela aplica de novo no ponto de leitura.
    // A URL traz `dias` como texto; só texto e número viram número.
    ...faixaDaBuscaDePrazos({
      status: texto(status),
      vence,
      dias:
        typeof dias === "string" && dias !== ""
          ? Number(dias)
          : typeof dias === "number"
            ? dias
            : undefined,
    }),
    // TUT-204c — ver `/pericias`: mesma regra, filtro próprio.
    ...(isColunaDaLista("deadlines", sort) ? { sort } : {}),
    ...(isDirecaoDeOrdenacao(dir) ? { dir } : {}),
    page: pagina(page),
  } as PrazosSearch;
}
